module.exports = __webpack_public_path__ + "e99967ab.png";